import { render } from "./BaseDisabledInput.vue?vue&type=template&id=3eb8ed18&scoped=true"
import script from "./BaseDisabledInput.vue?vue&type=script&lang=js"
export * from "./BaseDisabledInput.vue?vue&type=script&lang=js"

import "./BaseDisabledInput.vue?vue&type=style&index=0&id=3eb8ed18&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb8ed18"]])

export default __exports__